import { usePbProps } from '@content/helpers/src/context.tsx'
import { Chip } from '@nespresso-design-system/components'
import styles from './CategoriesChips.module.scss'
import { selectPromotion } from '@content/helpers/src/gtmEvents.js'

const CategoriesChips = ({ categoryCallback, activeCategory }) => {
    const { copywriting, campaign }: any = usePbProps()
    const { categories } = copywriting

    const handleChip = (id: any, label: string, index: number) => {
        categoryCallback(id)

        selectPromotion({
            ...campaign,
            cta_name: `menu chip - ${index + 1} - ${label}`
        })
    }

    return (
        <ul className={styles.featuredProducts__categories}>
            {categories.map((category, index) => (
                <li>
                    <Chip
                        {...category}
                        icon={category.icon}
                        key={category.id}
                        onClick={() =>
                            handleChip(category.id, category.label, index)
                        }
                        isActive={category.id === activeCategory}
                        isSelected={category.id === activeCategory}
                    />
                </li>
            ))}
        </ul>
    )
}

export default CategoriesChips
